import { reactive, ref } from 'vue'

export const seekedTime = ref(0);

export function updateSeekedTime(data) {
if(data) seekedTime.value = data;
}